import React from "react";

const SadFaceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="sad_face_icon"
      data-name="sad face"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9987 1.33325C4.3227 1.33325 1.33203 4.32392 1.33203 7.99992C1.33203 11.6759 4.3227 14.6666 7.9987 14.6666C11.6747 14.6666 14.6654 11.6759 14.6654 7.99992C14.6654 4.32392 11.6747 1.33325 7.9987 1.33325ZM7.9987 13.3333C5.05803 13.3333 2.66536 10.9406 2.66536 7.99992C2.66536 5.05925 5.05803 2.66659 7.9987 2.66659C10.9394 2.66659 13.332 5.05925 13.332 7.99992C13.332 10.9406 10.9394 13.3333 7.9987 13.3333Z"
        fill={props.fill || "#A40101"}
      />
      <path
        d="M5.66797 8C6.22025 8 6.66797 7.55228 6.66797 7C6.66797 6.44772 6.22025 6 5.66797 6C5.11568 6 4.66797 6.44772 4.66797 7C4.66797 7.55228 5.11568 8 5.66797 8Z"
        fill={props.fill || "#A40101"}
      />
      <path
        d="M10.3274 7.99067C10.8771 7.99067 11.3227 7.54504 11.3227 6.99533C11.3227 6.44563 10.8771 6 10.3274 6C9.77766 6 9.33203 6.44563 9.33203 6.99533C9.33203 7.54504 9.77766 7.99067 10.3274 7.99067Z"
        fill={props.fill || "#A40101"}
      />
      <path
        d="M7.9987 9.33325C5.9987 9.33325 5.33203 11.3333 5.33203 11.3333H10.6654C10.6654 11.3333 9.9987 9.33325 7.9987 9.33325Z"
        fill={props.fill || "#A40101"}
      />
    </svg>
  );
};

export default SadFaceIcon;
